module.exports = __webpack_public_path__ + "img/lyzz_login.8c06c5e4.png";